module.exports = __webpack_public_path__ + "static/media/Direkt Hälsa uses Curoflow Telemedicine platform.0f94d7f7.webp";